import React from 'react';
import PropTypes from 'prop-types';

const SvgIcon = ({ icon, className, sprite }) => (
  <svg className={className}>
    <use xlinkHref={`${sprite || ''}#${icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
  </svg>
);

export default SvgIcon;



// WEBPACK FOOTER //
// ./app/javascript/common/SvgIcon.js